import { render } from "./LogDownloadsUpdatesComponent.vue?vue&type=template&id=1cfeadab&scoped=true"
import script from "./LogDownloadsUpdatesComponent.vue?vue&type=script&lang=js"
export * from "./LogDownloadsUpdatesComponent.vue?vue&type=script&lang=js"

import "./LogDownloadsUpdatesComponent.vue?vue&type=style&index=0&id=1cfeadab&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfeadab"]])

export default __exports__